export const exitIntentDemo = 'https://demo.arcade.software/Q8v3dl1swQJq28LXyTSK?embed&embed_mobile=inline&embed_desktop=inline&show_copy_link=true';